<template>
    <ul class="sidebar navbar-nav">
       
        <!-- <li class="nav-item" :class="{ active: index == 2}">
          <router-link class="nav-link" to="/casting_permisstion">
            <i class="fas fa-user-shield"></i>
            <span>Permission</span>
          </router-link>
        </li>
        <li class="nav-item" :class="{ active: index == 3}">
          <router-link class="nav-link" to="/casting_role">
            <i class="fas fa-tasks"></i>
            <span>Role</span>
          </router-link>
        </li> -->
        <li class="nav-item" :class="{ active: index == 2}" v-if="bonus_ep">
          <router-link class="nav-link" to="/bonus_Rate1">
            <i class="fas fa-folder"></i>
            <span>EP</span>
          </router-link>
        </li>
        <li class="nav-item" :class="{ active: index == 3}" v-if="bonus_pro_position">
          <router-link class="nav-link" to="/bonus_position/Production">
            <i class="fas fa-book"></i>
            <span>Production Position</span>
          </router-link>
        </li>
        <li class="nav-item" :class="{ active: index == 5}" v-if="bonus_post_position">
          <router-link class="nav-link" to="/bonus_position2/Post">
            <i class="fas fa-landmark"></i>
            <span>Post Position</span>
          </router-link>
        </li>
        <li class="nav-item" :class="{ active: index == 4}" v-if="bonus_template">
          <router-link class="nav-link" to="/bonus_Grouptemplate">
            <i class="fas fa-user-shield"></i>
            <span>Template</span>
          </router-link>
        </li>
        <li class="nav-item" :class="{ active: index == 1}" v-if="bonus_group">
          <router-link class="nav-link" to="/bonus_group">
            <i class="fas fa-users"></i>
            <span>Group</span>
          </router-link>
        </li>
        <li class="nav-item" :class="{ active: index == 6}" v-if="bonus_permission">
          <router-link class="nav-link" to="/bonus_Permission">
            <i class="fas fa-eye"></i>
            <span>Permission</span>
          </router-link>
        </li>
        <li class="nav-item" :class="{ active: index == 8}">
          <router-link class="nav-link" to="/bonus_Note">
            <i class="fas fa-sticky-note"></i>
            <span>Note</span>
          </router-link>
        </li>
      </ul>
  </template>
  
  <script>
  export default {
    name: "BonusBar",
    props: ['index'],
    computed:{
    bonus_ep() {
      return this.$store.getters.hasPermission("bonus_ep");
    },
    bonus_pro_position() {
      return this.$store.getters.hasPermission("bonus_pro_position");
    },
    bonus_post_position() {
      return this.$store.getters.hasPermission("bonus_post_position");
    },
    bonus_template() {
      return this.$store.getters.hasPermission("bonus_template");
    },
    bonus_group() {
      return this.$store.getters.hasPermission("bonus_group");
    },
    bonus_permission() {
      return this.$store.getters.hasPermission("bonus_permission");
    },
    }
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  </style>
  